import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion } from "framer-motion";
import { HONEYBOOK_URL, MEDIA } from "../data/site";

const LINKS = [
    { label: "Home", path: "/", testid: "nav-link-home" },
    { label: "Gallery", path: "/gallery", testid: "nav-link-gallery" },
    { label: "Packages", path: "/packages", testid: "nav-link-packages" },
    { label: "About", path: "/about", testid: "nav-link-about" },
    { label: "FAQ", path: "/faq", testid: "nav-link-faq" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const location = useLocation();

    return (
        <motion.header
            data-testid="site-header"
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="sticky top-0 z-50 bg-[#FAF7F2]/80 backdrop-blur-xl border-b border-[#E8C4C1]/60"
        >
            <div className="max-w-6xl mx-auto px-5 sm:px-8 flex items-center justify-between h-16 sm:h-20">
                <Link
                    to="/"
                    data-testid="nav-logo"
                    className="flex items-center group"
                    onClick={() => setOpen(false)}
                >
                    <img
                        src={MEDIA.logo}
                        alt="Enchanting Escapes — luxury event styling, McKinney TX"
                        className="h-10 sm:h-14 w-auto group-hover:scale-[1.03] transition-transform duration-500"
                    />
                </Link>

                <nav className="hidden md:flex items-center gap-7" aria-label="Primary">
                    {LINKS.map((l) => (
                        <NavLink
                            key={l.path}
                            to={l.path}
                            data-testid={l.testid}
                            className={({ isActive }) =>
                                `font-accent text-xs uppercase tracking-[0.18em] transition-colors relative ${
                                    isActive
                                        ? "text-[#554011] font-semibold"
                                        : "text-[#6E5B3D] hover:text-[#554011]"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <a
                        href={HONEYBOOK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="header-honeybook-cta"
                        className="bg-[#554011] hover:bg-[#3D2E0A] text-[#FAF7F2] px-6 py-2.5 rounded-full font-accent text-xs uppercase tracking-[0.18em] transition-all duration-300 shadow-sm hover:shadow-md hover:scale-[1.04]"
                    >
                        Book Now
                    </a>
                </nav>

                <button
                    data-testid="mobile-menu-toggle"
                    className="md:hidden p-2 text-[#554011]"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                >
                    {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                </button>
            </div>

            {open && (
                <nav
                    data-testid="mobile-menu"
                    className="md:hidden border-t border-[#E8C4C1]/60 bg-[#FAF7F2] px-5 py-6 flex flex-col gap-5"
                    aria-label="Mobile"
                >
                    {LINKS.map((l) => (
                        <NavLink
                            key={l.path}
                            to={l.path}
                            data-testid={`mobile-${l.testid}`}
                            onClick={() => setOpen(false)}
                            className={`font-accent text-sm uppercase tracking-[0.18em] ${
                                location.pathname === l.path
                                    ? "text-[#554011] font-semibold"
                                    : "text-[#6E5B3D]"
                            }`}
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <a
                        href={HONEYBOOK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="mobile-header-honeybook-cta"
                        className="bg-[#554011] text-[#FAF7F2] text-center px-6 py-3 rounded-full font-accent text-xs uppercase tracking-[0.18em]"
                    >
                        Book Now
                    </a>
                </nav>
            )}
        </motion.header>
    );
};
